/////////////adding gotopage and gotoimage


// import React, { useState } from "react";
// import { Home, Search, X } from "lucide-react";

// const ImageList = ({
//   isSidebarCollapsed,
//   batchName,
//   ridName,
//   user,
//   navigate,
//   searchTerm,
//   setSearchTerm,
//   isListLoading,
//   filteredImages,
//   currentPage,
//   itemsPerPage,
//   selectedImage,
//   handleImageSelect,
//   prefetchedImages,
//   handlePageChange,
//   isMultiSearchMode,
//   onMultiImageSearch,
//   onClearMultiSearch,
// }) => {
//   const totalPages = Math.ceil(filteredImages.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentImages = filteredImages.slice(startIndex, endIndex);

//   // State for "Go to page" input
//   const [pageInputValue, setPageInputValue] = useState("");
  
//   // State for "Find image" input
//   const [imageNameInput, setImageNameInput] = useState("");

//   const handleKeyPress = (e) => {
//     // Trigger search on Enter key if not in multi-search mode
//     if (e.key === 'Enter' && searchTerm.trim() && !isMultiSearchMode) {
//       onMultiImageSearch();
//     }
//   };

//   const handlePageInputChange = (e) => {
//     const value = e.target.value;
//     // Only allow numbers
//     if (value === "" || /^\d+$/.test(value)) {
//       setPageInputValue(value);
//     }
//   };

//   const handleGoToPage = () => {
//     const pageNum = parseInt(pageInputValue);
//     if (pageNum && pageNum >= 1 && pageNum <= totalPages) {
//       handlePageChange(pageNum);
//       setPageInputValue("");
//     }
//   };

//   const handlePageInputKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleGoToPage();
//     }
//   };

//   const handleImageNameChange = (e) => {
//     setImageNameInput(e.target.value);
//   };

// const handleFindImage = () => {
//   if (!imageNameInput.trim()) return;

//   // Remove extension from search input if present
//   const searchTerm = imageNameInput.trim().replace(/\.(jpg|jpeg|png|gif|bmp|tiff|tif|webp)$/i, '');

//   // Find the image in filtered images
//   const imageIndex = filteredImages.findIndex(img => {
//     // Get filename without extension for comparison
//     const filenameWithoutExt = img.filename.replace(/\.(jpg|jpeg|png|gif|bmp|tiff|tif|webp)$/i, '');
    
//     return filenameWithoutExt.toLowerCase().includes(searchTerm.toLowerCase()) ||
//            // Also check the full filename in case user provided extension
//            img.filename.toLowerCase().includes(searchTerm.toLowerCase());
//   });

//   if (imageIndex !== -1) {
//     // Calculate which page this image is on
//     const targetPage = Math.ceil((imageIndex + 1) / itemsPerPage);
    
//     // Navigate to that page
//     handlePageChange(targetPage);
    
//     // Select the image
//     handleImageSelect(filteredImages[imageIndex].filename);
    
//     // Clear the input
//     setImageNameInput("");
//   } else {
//     // Show error notification or alert
//     alert(`No image found matching "${imageNameInput}"`);
//   }
// };

//   const handleImageNameKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleFindImage();
//     }
//   };

//   return (
//     <div
//       className={`bg-white border-r border-gray-200 overflow-y-auto transition-all duration-300 ease-in-out ${
//         isSidebarCollapsed ? "w-0" : "w-1/4"
//       }`}
//       style={{ minWidth: isSidebarCollapsed ? "0" : "250px" }}
//     >
//       <div className={`p-4 ${isSidebarCollapsed ? "hidden" : "block"}`}>
//         <div className="mb-6">
//           <div className="flex items-center justify-between mb-4">
//            <div className="flex-1 min-w-0">
//   <h2 className="text-xl font-semibold truncate">Batch Viewer</h2>
  
//   {/* Display RID and Batch Name */}
//   <div className="mt-2 space-y-1">
//     <div className="flex items-center gap-2">
//       <span className="text-xs font-semibold text-gray-500 uppercase">RID:</span>
//       <p className="text-sm text-gray-700 font-medium truncate">
//         {decodeURIComponent(ridName)}
//       </p>
//     </div>
//     <div className="flex items-center gap-2">
//       <span className="text-xs font-semibold text-gray-500 uppercase">Batch:</span>
//       <p className="text-sm text-gray-700 font-medium truncate">
//         {decodeURIComponent(batchName)}
//       </p>
//     </div>
//   </div>
  
//   {user && (
//     <p className="text-xs text-gray-500 mt-2 truncate">
//       {user.email}
//     </p>
//   )}
// </div>
//             <div className="flex gap-2 ml-2">
//               <button
//                 onClick={() => navigate("/")}
//                 className="flex items-center gap-2 px-3 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
//                 title="Back to Home"
//               >
//                 <Home className="w-4 h-4" />
//                 <span className="hidden lg:inline">Home</span>
//               </button>
//             </div>
//           </div>

//           <div className="mb-4">
//             <div className="relative">
//               <textarea
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 placeholder="Search images... "
//                 className="w-full p-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 resize-none"
//                 rows={isMultiSearchMode ? 4 : 2}
//               />
//               {searchTerm && (
//                 <button
//                   onClick={() => {
//                     setSearchTerm("");
//                     if (isMultiSearchMode) {
//                       onClearMultiSearch();
//                     }
//                   }}
//                   className="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
//                   title="Clear search"
//                 >
//                   <X className="w-4 h-4" />
//                 </button>
//               )}
//             </div>
            
//             <div className="flex gap-2 mt-2">
//               <button
//                 onClick={onMultiImageSearch}
//                 disabled={!searchTerm.trim()}
//                 className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 text-sm rounded transition-colors ${
//                   searchTerm.trim()
//                     ? "bg-blue-500 hover:bg-blue-600 text-white"
//                     : "bg-gray-200 text-gray-400 cursor-not-allowed"
//                 }`}
//                 title="Search for multiple images"
//               >
//                 <Search className="w-4 h-4" />
//                 Search Images
//               </button>
              
//               {isMultiSearchMode && (
//                 <button
//                   onClick={onClearMultiSearch}
//                   className="px-3 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
//                   title="Show all images"
//                 >
//                   Show All
//                 </button>
//               )}
//             </div>

//             {isMultiSearchMode && (
//               <div className="mt-2 p-2 bg-blue-50 border border-blue-200 rounded text-xs text-blue-700">
//                 <strong>Multi-search active:</strong> Showing {filteredImages.length} matched image(s)
//               </div>
//             )}

//           </div>
//              {/* Find Image Input */}
//                 <div className="flex items-center gap-2">
//                   <span className="text-sm text-gray-600 whitespace-nowrap">Find:</span>
//                   <input
//                     type="text"
//                     value={imageNameInput}
//                     onChange={handleImageNameChange}
//                     onKeyPress={handleImageNameKeyPress}
//                     placeholder="Enter image name..."
//                     className="flex-1 px-3 py-1.5 text-sm border border-gray-300 rounded focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
//                   />
//                   <button
//                     onClick={handleFindImage}
//                     disabled={!imageNameInput.trim()}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       imageNameInput.trim()
//                         ? "bg-green-500 hover:bg-green-600 text-white"
//                         : "bg-gray-200 text-gray-400 cursor-not-allowed"
//                     }`}
//                   >
//                     Find
//                   </button>
//                 </div>
//         </div>

//         {isListLoading ? (
//           <div className="flex items-center justify-center p-4">
//             <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
//           </div>
//         ) : (
//           <>
//             <div className="space-y-2 mb-4">
//               {currentImages.length > 0 ? (
//                 currentImages.map((image, index) => (
//                   <div
//                     key={image.filename}
//                     onClick={() => handleImageSelect(image.filename)}
//                     className={`group relative p-3 rounded-lg border transition-all duration-200 cursor-pointer ${
//                       selectedImage === image.filename
//                         ? "bg-blue-50 border-blue-500 shadow-md"
//                         : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
//                     }`}
//                   >
//                     <div className="flex justify-between items-start gap-2">
//                       <div className="relative flex-1 min-w-0">
//                         <p className="text-sm font-medium text-gray-700 break-all leading-tight">
//                           {image.filename}
//                         </p>
//                         {prefetchedImages.has(`${image.filename}_lowres`) && (
//                           <span className="text-xs text-green-600 mt-1 block">
//                             ✓ Ready
//                           </span>
//                         )}
//                         <div className="absolute left-0 -top-2 transform -translate-y-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
//                           <div className="bg-gray-900 text-white px-3 py-2 rounded text-xs whitespace-normal break-words max-w-xs">
//                             {image.filename}
//                           </div>
//                           <div className="w-2 h-2 bg-gray-900 transform rotate-45 translate-x-2 translate-y-[-4px] ml-2"></div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center py-8 text-gray-500">
//                   {isMultiSearchMode
//                     ? "No images match your multi-search criteria"
//                     : searchTerm
//                     ? "No images match your search"
//                     : "No images in this batch"}
//                 </div>
//               )}
//             </div>

//             {totalPages > 0 && (
//               <div className="border-t border-gray-200 pt-4 space-y-3">
//                 <div className="flex items-center justify-between">
//                   <button
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                     className={`px-3 py-1 rounded ${
//                       currentPage === 1
//                         ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                         : "bg-blue-500 text-white hover:bg-blue-600"
//                     }`}
//                   >
//                     Previous
//                   </button>
//                   <span className="text-sm text-gray-600">
//                     Page {currentPage} of {totalPages}
//                   </span>
//                   <button
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                     className={`px-3 py-1 rounded ${
//                       currentPage === totalPages
//                         ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                         : "bg-blue-500 text-white hover:bg-blue-600"
//                     }`}
//                   >
//                     Next
//                   </button>
//                 </div>

//                 {/* Go to Page Input */}
//                 <div className="flex items-center gap-2">
//                   <span className="text-sm text-gray-600 whitespace-nowrap">Go to:</span>
//                   <input
//                     type="text"
//                     value={pageInputValue}
//                     onChange={handlePageInputChange}
//                     onKeyPress={handlePageInputKeyPress}
//                     placeholder={`1-${totalPages}`}
//                     className="flex-1 px-3 py-1.5 text-sm border border-gray-300 rounded focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
//                   />
//                   <button
//                     onClick={handleGoToPage}
//                     disabled={!pageInputValue || parseInt(pageInputValue) < 1 || parseInt(pageInputValue) > totalPages}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       pageInputValue && parseInt(pageInputValue) >= 1 && parseInt(pageInputValue) <= totalPages
//                         ? "bg-blue-500 hover:bg-blue-600 text-white"
//                         : "bg-gray-200 text-gray-400 cursor-not-allowed"
//                     }`}
//                   >
//                     Go
//                   </button>
//                 </div>

             

//                 <div className="text-center">
//                   <span className="text-xs text-gray-500">
//                     {filteredImages.length} total images
//                     {isMultiSearchMode && " (filtered)"}
//                   </span>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ImageList;


import React, { useState } from "react";
import { Home, Search, X } from "lucide-react";

const ImageList = ({
  isSidebarCollapsed,
  batchName,
  ridName,
  user,
  navigate,
  searchTerm,
  setSearchTerm,
  isListLoading,
  filteredImages,
  currentPage,
  itemsPerPage,
  selectedImage,
  handleImageSelect,
  prefetchedImages,
  handlePageChange,
  isMultiSearchMode,
  onMultiImageSearch,
  onClearMultiSearch,
}) => {
  const totalPages = Math.ceil(filteredImages.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentImages = filteredImages.slice(startIndex, endIndex);

  // State for "Go to page" input
  const [pageInputValue, setPageInputValue] = useState("");
  
  // State for "Find image" input
  const [imageNameInput, setImageNameInput] = useState("");

  const handleKeyPress = (e) => {
    // Trigger search on Enter key if not in multi-search mode
    if (e.key === 'Enter' && searchTerm.trim() && !isMultiSearchMode) {
      onMultiImageSearch();
    }
  };

  const handlePageInputChange = (e) => {
    const value = e.target.value;
    // Only allow numbers
    if (value === "" || /^\d+$/.test(value)) {
      setPageInputValue(value);
    }
  };

  const handleGoToPage = () => {
    const pageNum = parseInt(pageInputValue);
    if (pageNum && pageNum >= 1 && pageNum <= totalPages) {
      handlePageChange(pageNum);
      setPageInputValue("");
    }
  };

  const handlePageInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleGoToPage();
    }
  };

  const handleImageNameChange = (e) => {
    setImageNameInput(e.target.value);
  };

const handleFindImage = () => {
  if (!imageNameInput.trim()) return;

  // Remove extension from search input if present
  const searchTerm = imageNameInput.trim().replace(/\.(jpg|jpeg|png|gif|bmp|tiff|tif|webp)$/i, '');

  // Find the image in filtered images
  const imageIndex = filteredImages.findIndex(img => {
    // Get filename without extension for comparison
    const filenameWithoutExt = img.filename.replace(/\.(jpg|jpeg|png|gif|bmp|tiff|tif|webp)$/i, '');
    
    return filenameWithoutExt.toLowerCase().includes(searchTerm.toLowerCase()) ||
           // Also check the full filename in case user provided extension
           img.filename.toLowerCase().includes(searchTerm.toLowerCase());
  });

  if (imageIndex !== -1) {
    // Calculate which page this image is on
    const targetPage = Math.ceil((imageIndex + 1) / itemsPerPage);
    
    // Navigate to that page
    handlePageChange(targetPage);
    
    // Select the image
    handleImageSelect(filteredImages[imageIndex].filename);
    
    // Clear the input
    setImageNameInput("");
  } else {
    // Show error notification or alert
    alert(`No image found matching "${imageNameInput}"`);
  }
};

  const handleImageNameKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleFindImage();
    }
  };

  return (
    <div
      className={`bg-white border-r border-gray-200 overflow-y-auto transition-all duration-300 ease-in-out ${
        isSidebarCollapsed ? "w-0" : "w-1/4"
      }`}
      style={{ minWidth: isSidebarCollapsed ? "0" : "250px" }}
    >
      <div className={`p-4 ${isSidebarCollapsed ? "hidden" : "block"}`}>
        <div className="mb-6">
          <div className="flex items-center justify-between mb-4">
           <div className="flex-1 min-w-0">
  <h2 className="text-xl font-semibold truncate">Batch Viewer</h2>
  
  {/* Display RID and Batch Name */}
  <div className="mt-2 space-y-1">
    <div className="flex items-center gap-2">
      <span className="text-xs font-semibold text-gray-500 uppercase">RID:</span>
      <p className="text-sm text-gray-700 font-medium truncate">
        {decodeURIComponent(ridName)}
      </p>
    </div>
    <div className="flex items-center gap-2">
      <span className="text-xs font-semibold text-gray-500 uppercase">Batch:</span>
      <p className="text-sm text-gray-700 font-medium truncate">
        {decodeURIComponent(batchName)}
      </p>
    </div>
  </div>
  
  {user && (
    <p className="text-xs text-gray-500 mt-2 truncate">
      {user.email}
    </p>
  )}
</div>
            <div className="flex gap-2 ml-2">
              <button
                onClick={() => navigate("/")}
                className="flex items-center gap-2 px-3 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
                title="Back to Home"
              >
                <Home className="w-4 h-4" />
                <span className="hidden lg:inline">Home</span>
              </button>
            </div>
          </div>

          <div className="mb-4">
            <div className="relative">
              <textarea
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Search images... "
                className="w-full p-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 resize-none"
                rows={isMultiSearchMode ? 4 : 2}
              />
              {searchTerm && (
                <button
                  onClick={() => {
                    setSearchTerm("");
                    if (isMultiSearchMode) {
                      onClearMultiSearch();
                    }
                  }}
                  className="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
                  title="Clear search"
                >
                  <X className="w-4 h-4" />
                </button>
              )}
            </div>
            
            <div className="flex gap-2 mt-2">
              <button
                onClick={onMultiImageSearch}
                disabled={!searchTerm.trim()}
                className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 text-sm rounded transition-colors ${
                  searchTerm.trim()
                    ? "bg-blue-500 hover:bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-400 cursor-not-allowed"
                }`}
                title="Search for multiple images"
              >
                <Search className="w-4 h-4" />
                Search Images
              </button>
              
              {isMultiSearchMode && (
                <button
                  onClick={onClearMultiSearch}
                  className="px-3 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
                  title="Show all images"
                >
                  Show All
                </button>
              )}
            </div>

            {isMultiSearchMode && (
              <div className="mt-2 p-2 bg-blue-50 border border-blue-200 rounded text-xs text-blue-700">
                <strong>Multi-search active:</strong> Showing {filteredImages.length} matched image(s)
              </div>
            )}

          </div>
             {/* Find Image Input */}
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-600 whitespace-nowrap">Find:</span>
                  <input
                    type="text"
                    value={imageNameInput}
                    onChange={handleImageNameChange}
                    onKeyPress={handleImageNameKeyPress}
                    placeholder="Enter image name..."
                    className="flex-1 px-3 py-1.5 text-sm border border-gray-300 rounded focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <button
                    onClick={handleFindImage}
                    disabled={!imageNameInput.trim()}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      imageNameInput.trim()
                        ? "bg-green-500 hover:bg-green-600 text-white"
                        : "bg-gray-200 text-gray-400 cursor-not-allowed"
                    }`}
                  >
                    Find
                  </button>
                </div>
        </div>

        {isListLoading ? (
          <div className="flex items-center justify-center p-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          </div>
        ) : (
          <>
            <div className="space-y-2 mb-4">
              {currentImages.length > 0 ? (
                currentImages.map((image, index) => (
                  <div
                    key={image.filename}
                    onClick={() => handleImageSelect(image.filename)}
                    className={`group relative p-3 rounded-lg border transition-all duration-200 cursor-pointer ${
                      selectedImage === image.filename
                        ? "bg-blue-50 border-blue-500 shadow-md"
                        : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
                    }`}
                  >
                    <div className="flex justify-between items-start gap-2">
                      <div className="relative flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-700 break-all leading-tight">
                          {image.filename}
                        </p>
                        {prefetchedImages.has(`${image.filename}_lowres`) && (
                          <span className="text-xs text-green-600 mt-1 block">
                            ✓ Ready
                          </span>
                        )}
                        <div className="absolute left-0 -top-2 transform -translate-y-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
                          <div className="bg-gray-900 text-white px-3 py-2 rounded text-xs whitespace-normal break-words max-w-xs">
                            {image.filename}
                          </div>
                          <div className="w-2 h-2 bg-gray-900 transform rotate-45 translate-x-2 translate-y-[-4px] ml-2"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-8 text-gray-500">
                  {isMultiSearchMode
                    ? "No images match your multi-search criteria"
                    : searchTerm
                    ? "No images match your search"
                    : "No images in this batch"}
                </div>
              )}
            </div>

            {totalPages > 0 && (
              <div className="border-t border-gray-200 pt-4 space-y-3">
                <div className="flex items-center justify-between">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`px-3 py-1 rounded ${
                      currentPage === 1
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "bg-blue-500 text-white hover:bg-blue-600"
                    }`}
                  >
                    Previous
                  </button>
                  <span className="text-sm text-gray-600">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`px-3 py-1 rounded ${
                      currentPage === totalPages
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "bg-blue-500 text-white hover:bg-blue-600"
                    }`}
                  >
                    Next
                  </button>
                </div>

                {/* Go to Page Input */}
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-600 whitespace-nowrap">Go to:</span>
                  <input
                    type="text"
                    value={pageInputValue}
                    onChange={handlePageInputChange}
                    onKeyPress={handlePageInputKeyPress}
                    placeholder={`1-${totalPages}`}
                    className="flex-1 px-3 py-1.5 text-sm border border-gray-300 rounded focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <button
                    onClick={handleGoToPage}
                    disabled={!pageInputValue || parseInt(pageInputValue) < 1 || parseInt(pageInputValue) > totalPages}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      pageInputValue && parseInt(pageInputValue) >= 1 && parseInt(pageInputValue) <= totalPages
                        ? "bg-blue-500 hover:bg-blue-600 text-white"
                        : "bg-gray-200 text-gray-400 cursor-not-allowed"
                    }`}
                  >
                    Go
                  </button>
                </div>

             

                <div className="text-center">
                  <span className="text-xs text-gray-500">
                    {filteredImages.length} total images
                    {isMultiSearchMode && " (filtered)"}
                  </span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ImageList;